import React from "react";
import PropTypes from "prop-types";

import Header from "../components/Header";

import "../styles/main.css";

const Template = ({ children, location }) =>
  <div>
    <Header location={location.pathname} />
    {children()}
  </div>;

Template.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
  route: PropTypes.object
};

export default Template;



// WEBPACK FOOTER //
// ./src/layouts/index.js